<div class="modal-alta-container">
  <h3 class="title-header">Alta contable: NO</h3>
  <button type="button" class="close" aria-label="Close" (click)="closeModalAltaContable()" class="btn-close-modal">
    <mat-icon>clear</mat-icon>
  </button>
  <p class="modal-alta-text">
    El proveedor asignado para la prestación aún no completó su alta contable.
    Para realizar la misma, el prestador deberá realizar el alta generando un usuario en el siguiente <a href="/web/registro-proveedor">enlace</a>.
  </p>
</div>
